import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1809.88836,1806.67411 L1809.88836,1920 L110,1920 L110,1806.67411 L1809.88836,1806.67411 Z M477.538529,1391.22139 L621.009106,1486.86845 L560.719733,1580.02233 L326.815094,1580.02233 L477.538529,1391.22139 Z M616.816048,921.93888 L1006.77044,1182.13513 L974.019256,1233.58508 C958.266957,1260.66997 928.008944,1274.94903 898.770865,1269.62271 C826.015643,1256.70356 752.580466,1287.98151 711.10319,1350.42407 L683.111695,1392.128 L544.287478,1299.42742 L572.165648,1257.61017 C613.756249,1195.28093 614.662857,1115.0462 574.432165,1053.39691 C558.226563,1028.46522 559.926451,994.920754 578.058594,971.008991 L616.816048,921.93888 Z M1295.41148,118.911619 L1537.92889,280.740991 C1554.02116,291.50695 1558.32755,314.058803 1549.03483,330.264405 L1067.62644,1086.6014 L687.418078,832.86473 L1244.18818,129.677578 C1256.65403,113.018672 1279.20588,108.145659 1295.41148,118.911619 Z M312.649358,1693.34822 L622.482343,1693.34822 L745.667586,1502.62074 L805.390331,1413.20662 C821.822585,1388.6149 850.494035,1375.80907 878.032227,1381.02206 C954.527203,1395.30113 1032.15544,1358.92352 1070.68624,1292.62787 L1645.92846,389.080542 C1686.27248,319.385119 1666.55377,230.424295 1600.93808,186.45385 L1358.19403,24.6244777 C1292.57833,-19.0059902 1202.82423,-3.14036549 1154.66073,60.2088074 L488.53114,901.653546 C440.82094,964.436089 437.194512,1050.33711 479.578395,1115.15952 C494.87739,1138.84464 494.197435,1170.12258 477.878506,1194.82763 L419.628999,1282.08856 L229.468154,1520.52624 C203.629851,1552.82411 198.756838,1596.00128 216.662328,1633.17217 C234.567819,1670.22974 271.398734,1693.34822 312.649358,1693.34822 L312.649358,1693.34822 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHighlighterLine = /*#__PURE__*/function (_Component) {
  _inherits(IconHighlighterLine, _Component);

  var _super = _createSuper(IconHighlighterLine);

  function IconHighlighterLine() {
    _classCallCheck(this, IconHighlighterLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconHighlighterLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHighlighter",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconHighlighterLine.displayName = "IconHighlighterLine";
  return IconHighlighterLine;
}(Component);

IconHighlighterLine.glyphName = 'highlighter';
IconHighlighterLine.variant = 'Line';
IconHighlighterLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHighlighterLine;
export { IconHighlighterLine };